module.exports = __webpack_public_path__ + "img/jo.svg";